import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GmailRegular from './gmail-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GmailRegular {...validProps} />;
}
SvgComponent.iconName = 'gmailRegular';

export const GmailRegularIcon = svgIconWrapper(SvgComponent);
